import { render, staticRenderFns } from "./DictTypeForm.vue?vue&type=template&id=77ea2198&"
import script from "./DictTypeForm.vue?vue&type=script&lang=js&"
export * from "./DictTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports